
import Vue from 'vue';
import WistiaVideo from '@/components/layout/wistia-video.vue';

export default Vue.extend({
  name: 'ModalVideoLayout',
  components: {
    WistiaVideo,
  },
  props: {
    id: String,
    popover: {
      type: Boolean,
      default: true,
    },
  },
});
